"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e){return e};
